var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "v-col",
    {
      attrs: {
        cols: "12"
      }
    },
    [
      _c(
        "gg-card",
        [
          _c("gg-card-header", [_vm._v(" Your Email Accounts ")]),
          _c(
            "gg-card-text",
            [
              _c("v-data-table", {
                attrs: {
                  headers: _vm.headers,
                  items: _vm.emails.data,
                  loading: _vm.emails.loading_status
                },
                scopedSlots: _vm._u([
                  {
                    key: "item.email",
                    fn: function fn(_ref) {
                      var item = _ref.item
                      return [_vm._v(" " + _vm._s(item.email) + " ")]
                    }
                  },
                  {
                    key: "item.usage",
                    fn: function fn(_ref2) {
                      var item = _ref2.item
                      return [
                        item.humandiskquota !== "None"
                          ? _c("v-progress-linear", {
                              attrs: {
                                color: "primary",
                                height: "26",
                                value: _vm.quotaPercentage(
                                  item.diskusedpercent_float
                                )
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function fn(_ref3) {
                                      var value = _ref3.value
                                      return [
                                        _vm._v(
                                          " " +
                                            _vm._s(item.humandiskused) +
                                            " / " +
                                            _vm._s(item.humandiskquota) +
                                            " "
                                        )
                                      ]
                                    }
                                  }
                                ],
                                null,
                                true
                              )
                            })
                          : _c("v-progress-linear", {
                              attrs: {
                                color: "primary",
                                height: "26",
                                value: "0"
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function fn(_ref4) {
                                      var value = _ref4.value
                                      return [
                                        _vm._v(
                                          " " +
                                            _vm._s(item.humandiskused) +
                                            " / ∞ "
                                        )
                                      ]
                                    }
                                  }
                                ],
                                null,
                                true
                              )
                            })
                      ]
                    }
                  },
                  {
                    key: "item.manage",
                    fn: function fn(_ref5) {
                      var item = _ref5.item
                      return [
                        _c(
                          "div",
                          {},
                          [
                            _c(
                              "gg-btn",
                              {
                                staticClass: "mr-2",
                                attrs: {
                                  secondary: ""
                                },
                                on: {
                                  click: function click($event) {
                                    return _vm.launch_webmail(
                                      _vm.hosting.id,
                                      item.email
                                    )
                                  }
                                }
                              },
                              [
                                _vm._v(" Check Webmail "),
                                _c(
                                  "v-icon",
                                  {
                                    staticClass: "ml-1",
                                    attrs: {
                                      small: ""
                                    }
                                  },
                                  [_vm._v("mdi-open-in-new")]
                                )
                              ],
                              1
                            ),
                            _c(
                              "v-menu",
                              {
                                attrs: {
                                  bottom: "",
                                  "offset-y": "",
                                  "min-width": "180"
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "activator",
                                      fn: function fn(_ref6) {
                                        var on = _ref6.on,
                                          attrs = _ref6.attrs
                                        return [
                                          _c(
                                            "gg-btn",
                                            _vm._g(
                                              _vm._b(
                                                {},
                                                "gg-btn",
                                                attrs,
                                                false
                                              ),
                                              on
                                            ),
                                            [
                                              _vm._v(" Manage "),
                                              _c(
                                                "v-icon",
                                                {
                                                  staticClass: "ml-1"
                                                },
                                                [_vm._v("mdi-chevron-down")]
                                              )
                                            ],
                                            1
                                          )
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  true
                                )
                              },
                              [
                                _c(
                                  "v-list",
                                  [
                                    _c(
                                      "v-list-item",
                                      {
                                        on: {
                                          click: function click($event) {
                                            return _vm.triggerPass(
                                              item.email,
                                              item.domain
                                            )
                                          }
                                        }
                                      },
                                      [
                                        _c("v-list-item-title", [
                                          _vm._v("Change Password")
                                        ])
                                      ],
                                      1
                                    ),
                                    _c(
                                      "v-list-item",
                                      {
                                        on: {
                                          click: function click($event) {
                                            return _vm.triggerQuota(
                                              item.user,
                                              item.domain
                                            )
                                          }
                                        }
                                      },
                                      [
                                        _c("v-list-item-title", [
                                          _vm._v("Change Quota")
                                        ])
                                      ],
                                      1
                                    ),
                                    _c(
                                      "v-list-item",
                                      {
                                        on: {
                                          click: function click($event) {
                                            return _vm.triggerConfiguration(
                                              item.login
                                            )
                                          }
                                        }
                                      },
                                      [
                                        _c("v-list-item-title", [
                                          _vm._v("Mail Configuration")
                                        ])
                                      ],
                                      1
                                    ),
                                    _c(
                                      "v-list-item",
                                      {
                                        on: {
                                          click: function click($event) {
                                            return _vm.triggerRemove(item.email)
                                          }
                                        }
                                      },
                                      [
                                        _c("v-list-item-title", [
                                          _vm._v("Delete")
                                        ])
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ]
                    }
                  }
                ])
              })
            ],
            1
          )
        ],
        1
      ),
      [
        _c(
          "div",
          [
            _c(
              "v-dialog",
              {
                attrs: {
                  "hide-overlay": "",
                  "max-width": "500px"
                },
                model: {
                  value: _vm.modals.password.open,
                  callback: function callback($$v) {
                    _vm.$set(_vm.modals.password, "open", $$v)
                  },
                  expression: "modals.password.open"
                }
              },
              [
                _vm.modals.password.open
                  ? _c("change-password", {
                      attrs: {
                        email: _vm.modals.password.email,
                        domain: _vm.modals.password.domain
                      },
                      on: {
                        close: _vm.triggerPass
                      }
                    })
                  : _vm._e()
              ],
              1
            )
          ],
          1
        )
      ],
      [
        _c(
          "div",
          [
            _c("change-quota", {
              attrs: {
                "is-active": _vm.modals.quota.open,
                user: _vm.modals.quota.user,
                domain: _vm.modals.quota.domain
              },
              on: {
                close: _vm.triggerQuota,
                "action-completed": _vm.getData
              }
            })
          ],
          1
        )
      ],
      [
        _c(
          "div",
          [
            _vm.modals.remove.open
              ? _c("delete-email", {
                  attrs: {
                    "is-active": _vm.modals.remove.open,
                    email: _vm.modals.remove.email
                  },
                  on: {
                    close: _vm.triggerRemove,
                    "action-completed": _vm.getData
                  }
                })
              : _vm._e()
          ],
          1
        )
      ],
      _c(
        "div",
        [
          _c("webmail-access-modal", {
            attrs: {
              domain: _vm.modals.access.domain,
              login: _vm.modals.access.login,
              opened: _vm.modals.access.open
            },
            on: {
              close: function close($event) {
                _vm.modals.access.open = false
              }
            }
          })
        ],
        1
      ),
      _c(
        "div",
        [
          _c("configuration-modal", {
            attrs: {
              opened: _vm.modals.configuration.open,
              account: _vm.modals.configuration.account
            },
            on: {
              close: function close($event) {
                _vm.modals.configuration.open = false
              }
            }
          })
        ],
        1
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }